export default "__VITE_ASSET__CrGsXD_e__"